import { DataType, WordType } from '../../types/SharedTypes';
import Tile from '../atoms/Tile';

type ListProps = {
	words: DataType['words'];
	getLabel: (key: string) => string;
};

export default function List(props: ListProps) {
	const { words, getLabel } = props;
	const classes = ['glossary__list'];

	return (
		<div className={classes.join(' ')}>
			{Object.entries(words).map(([letter, words]) => {
				// Skip empty groups.
				if (!Array.isArray(words) || words.length === 0) {
					return null;
				}

				return (
					<div key={`group-${letter}`} className="glossary__list-group">
						<div className="h3">{letter}</div>
						<div className="glossary__group-content">
							{words.map((word: WordType) => (
								<Tile key={word.key} word={word} getLabel={getLabel} />
							))}
						</div>
					</div>
				);
			})}
		</div>
	);
}
